var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowVectorCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5302 34.9694C31.5999 35.039 31.6552 35.1218 31.6929 35.2128C31.7306 35.3039 31.75 35.4014 31.75 35.5C31.75 35.5985 31.7306 35.6961 31.6929 35.7872C31.6552 35.8782 31.5999 35.9609 31.5302 36.0306C31.4606 36.1003 31.3778 36.1556 31.2868 36.1933C31.1957 36.231 31.0982 36.2504 30.9996 36.2504C30.9011 36.2504 30.8035 36.231 30.7124 36.1933C30.6214 36.1556 30.5387 36.1003 30.469 36.0306L22.969 28.5306C22.8993 28.461 22.8439 28.3782 22.8062 28.2872C22.7685 28.1961 22.749 28.0986 22.749 28C22.749 27.9014 22.7685 27.8038 22.8062 27.7128C22.8439 27.6217 22.8993 27.539 22.969 27.4694L30.469 19.9694C30.6097 19.8286 30.8006 19.7496 30.9996 19.7496C31.1986 19.7496 31.3895 19.8286 31.5302 19.9694C31.671 20.1101 31.75 20.301 31.75 20.5C31.75 20.699 31.671 20.8899 31.5302 21.0306L24.5599 28L31.5302 34.9694Z",
    fill: "#4D2A90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowVectorCarousel);
export default __webpack_public_path__ + "static/media/left-arrow-vector-carousel.b63e44bc8c3fd5e837fb4059a4b2b547.svg";
export { ForwardRef as ReactComponent };